import {constants} from './SharedRoomConstants'

let initialState ={
    saveSharedRoomInProgress:false
}

export const SharedRoomReducer = (state = initialState , action) => {
    switch(action.type){
        case constants.SAVE_SHARED_ROOM_IN_PROGRESS:
            return{...state , saveSharedRoomInProgress:true}
        case constants.SAVE_SHARED_ROOM_COMPLETE:
            return{...state , saveSharedRoomInProgress:false , data : action.data}
        default:
            return state;
    }
}

export default SharedRoomReducer